export default __webpack_public_path__ + "media/images/fonts/fontawesome-webfont-f775f9cca88e21d45bebe185b27c0e5b.svg";